import React from 'react';
import { IoMdClose } from 'react-icons/io';
import './styles.scss';

interface ModalListaStatusDiaProps {
    date: Date;
    pontos: any[];
    colaboradores: any[];
    feriados: any[];
    onClose: () => void;
    onSelectColaborador: (colaboradorId: number) => void;
}

const ModalListaStatusDia: React.FC<ModalListaStatusDiaProps> = ({ 
    date, 
    pontos, 
    colaboradores, 
    feriados, 
    onClose, 
    onSelectColaborador 
}) => {
    const dateFormatted = date.toLocaleDateString("pt-BR", { day: '2-digit', month: '2-digit', year: 'numeric' });
    const dateYYYYMMDD = date.toISOString().split('T')[0];
    const monthDay = dateYYYYMMDD.substring(5); // "MM-DD"
    const dayOfWeek = date.toLocaleDateString("pt-BR", { weekday: 'long' });

    // Check Feriados
    const feriado = feriados?.find((f: any) => {
        if (!f.data) return false;
        if (f.recorrente) return f.data.substring(5) === monthDay;
        return f.data === dateYYYYMMDD;
    });

    const isPast = new Date(dateYYYYMMDD) < new Date(new Date().toISOString().split('T')[0]);

    // Calcular o status para cada colaborador operacional
    const listaStatus = colaboradores.map(c => {
        let status = 'Falta';
        let badgeClass = 'status-falta';

        const isFeriado = !!feriado;
        const isAniversario = c.data_nascimento && c.data_nascimento.substring(5) === monthDay;

        // Se tem feriado e não bateu ponto, consideramos 'Feriado'
        if (isFeriado) {
            status = 'Feriado';
            badgeClass = 'status-feriado';
        }

        // Verifica pontos deste colaborador
        const pontosDoColab = pontos.filter(p => Number(p.colaboradorId) === Number(c.id) && p.data === dateFormatted);
        
        if (pontosDoColab.length > 0) {
            // Analisa atraso (se primeira batida foi depois das 08:30 por exemplo - simplificado)
            status = 'Em dia';
            badgeClass = 'status-em-dia';
            
            // Verifica pendências
            if (pontosDoColab.some(p => p.status === 'PENDENTE')) {
                status = 'Pendente';
                badgeClass = 'status-pendente';
            }
        } else if (!isPast) {
            status = 'Aguardando';
            badgeClass = 'status-aguardando';
        }

        return {
            ...c,
            status,
            badgeClass,
            isAniversario,
            totalPontos: pontosDoColab.length
        };
    });

    return (
        <div className="modal-lista-status__overlay" onClick={onClose}>
            <div className="modal-lista-status__container" onClick={e => e.stopPropagation()}>
                <div className="modal-lista-status__header">
                    <div>
                        <h2>Status Operacional Diário</h2>
                        <p className="modal-lista-status__sub">
                            {dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1)}, {dateFormatted}
                            {feriado && <span className="feriado-text"> - {feriado.nome}</span>}
                        </p>
                    </div>
                    <button className="btn-close" onClick={onClose}><IoMdClose size={22} /></button>
                </div>

                <div className="modal-lista-status__body">
                    <p className="instruction">Selecione um colaborador para realizar a auditoria dos pontos:</p>
                    
                    <div className="colab-list">
                        {listaStatus.map(colab => (
                            <div 
                                key={colab.id} 
                                className="colab-item" 
                                onClick={() => onSelectColaborador(Number(colab.id))}
                            >
                                <div className="colab-info">
                                    <span className="colab-name">
                                        {colab.nome} 
                                        {colab.isAniversario && <span title="Aniversariante" className="aniver-icon">🎂</span>}
                                    </span>
                                    <span className="colab-pontos">{colab.totalPontos} registro(s) encontrados</span>
                                </div>
                                <div className="colab-status">
                                    <span className={`status-badge ${colab.badgeClass}`}>{colab.status}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalListaStatusDia;
